import { Tag } from 'antd'
import { OUTLET_STATUS_OPTIONS } from '../../models/outlet.modal'

// Keys match backend OutletStatus* constants in libs/pkcore/entity/outlet.go.
const STATUS_COLOR: Record<string, string> = {
    lead: 'blue',
    contacted: 'cyan',
    consigning: 'gold',
    active: 'green',
    dormant: 'default',
    rejected: 'red',
}

export default function StatusTag({ status }: { status?: string }) {
    if (!status) return <Tag>—</Tag>
    const opt = OUTLET_STATUS_OPTIONS.find(o => o.value === status)
    const label = opt?.label ?? status
    return <Tag color={STATUS_COLOR[status] ?? 'default'}>{label}</Tag>
}
